import React, { useEffect, useState } from "react";
import { Card, Form, Tab, Table } from "react-bootstrap";
import { usePlannerContext } from "../../../contexts/planner.contexts";
import { convertValue, formatValue } from "../../../services/helperService";
import moment from "moment";

const FinancialProfile = ({ validated, submit }) => {
  const { plannerData, setOnChangeStatus } = usePlannerContext();

  const [formData, setformData] = useState({});

  useEffect(() => {
    if (
      plannerData &&
      typeof plannerData === "object" &&
      Object.keys(plannerData).length > 0
    ) {
      let payload = plannerData;
      setformData(payload);
    }
  }, [plannerData]);

  const handleBlurFP = (event, isFormat, setState) => {
    event.persist();
    let { name, value } = event.target;
    if (isFormat) {
      if (value) {
        value = value.replaceAll(",", "");
        value = parseFloat(value);
      }
      let formattedPrice = "";
      if (value) {
        formattedPrice = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(value);
      }

      setState((prevState) => ({
        ...prevState,
        [name]: formattedPrice ? formattedPrice : "0.00",
      }));
    } else {
      if (value) {
        value = value.replaceAll(",", "");
        value = parseFloat(value);
      }
      setState((prevState) => ({
        ...prevState,
        [name]: value ? value : "0",
      }));
    }
  };

  const handleFocusFP = (event, setState) => {
    event.persist();
    let { name, value } = event.target;
    if (value == "0.00" || value == "0.0" || value == "0" || value == "") {
      setState((prevState) => ({
        ...prevState,
        [name]: "",
      }));
    } else {
      value = value.slice(1);

      if (value) {
        const stringWithoutComma = value && value.replaceAll(",", "");
        setState((prevState) => ({
          ...prevState,
          [name]: stringWithoutComma ? stringWithoutComma : value,
        }));
      }
    }
  };

  const decodeHtml = (str) => {
    if (typeof str !== "string") return str;

    return str
      .replace(/&quot;/g, '"')
      .replace(/&#34;/g, '"')
      .replace(/&amp;/g, "&")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">");
  };

  const parseIfNeeded = (value) => {
    // Case 1: already a valid object/array
    if (typeof value === "object" && value !== null) {
      return value;
    }

    // Case 2: string → try parsing
    if (typeof value === "string") {
      try {
        const decoded = decodeHtml(value);
        const jsonValue = JSON.parse(decoded);
        if (jsonValue) {
          return jsonValue;
        }
      } catch (e) {
        return []; // or [] depending on your use case
      }
    }

    // Case 3: anything else
    return [];
  };

  const handleMaturityDate = (index, value) => {
    let data = parseIfNeeded(formData.s14_maturity_date);
    let saveData = {
      ...data,
      [index]: value,
    };

    handleStateByField("s14_maturity_date", saveData);
  };

  const handleInterestRate = (index, value) => {
    let data = parseIfNeeded(formData.s14_interest_rate);
    let saveData = {
      ...data,
      [index]: value,
    };

    handleStateByField("s14_interest_rate", saveData);
  };

  const handleStateByField = (name, value) => {
    setOnChangeStatus(true);

    setformData({
      ...formData,
      [name]: value,
    });
  };

  const submitFormdata = (event) => {
    submit(event, formData);
  };

  return (
    <>
      <Card.Body className="financialprofile-section">
        <Form
          id="financialprofile"
          name="financialprofile"
          noValidate
          validated={validated}
          onSubmit={submitFormdata}
          className="financialprofile-form"
        >
          <div className="text-center">
            <div className="head-title">Financial Profile</div>
          </div>
          <div className="fp-container mb-3">
            <div className="text-center mb-2">
              <div className="head-title2">
                Why is a Suitability Financial Profile Form Required?
              </div>
            </div>
          </div>
          <Table className="m-3 table-content table-one" responsive="md">
            <tbody>
              <tr>
                <td>
                  <label
                    className="retirement-label2 p-2"
                    onClick={() =>
                      handleStateByField(
                        "fp_attestation",
                        formData.fp_attestation == 1 ? 0 : 1
                      )
                    }
                  >
                    <div
                      className="retirement-label"
                      style={{ display: "inline" }}
                    >
                      {formData.fp_attestation &&
                      formData.fp_attestation !== "0" ? (
                        <i
                          className="fa fa-check-square-o checker"
                          // onClick={() =>
                          //   handleStateByField("fp_attestation", 0)
                          // }
                        ></i>
                      ) : (
                        <i
                          className="fa fa-square-o checker2"
                          // onClick={() =>
                          //   handleStateByField("fp_attestation", 1)
                          // }
                        ></i>
                      )}
                    </div>
                    By attestation below, you acknowledge the information you
                    have provided to us is accurate to the best of your ability.
                    Deficiencies or omissions in the information provided will
                    be reflected in the results we present to you. Based solely
                    upon the information provided by you, we will prepare a
                    report that will outline the benefits available to you in
                    retirement as of a specified date in the future. While the
                    information we will provide will be accurate to the best of
                    our ability, any deviation from the parameters you’ve
                    outlined, or deficiencies or omissions in the information
                    provided by you, will result in different financial
                    outcomes. We shall not be liable for such deviations,
                    deficiencies or omissions in the information provided. You
                    are instructed and encouraged to verify information with the
                    Office of Personnel Management.
                  </label>
                </td>
              </tr>
            </tbody>
          </Table>
          <Table className="m-3 table-content table-one" responsive="md">
            <tbody>
              <tr>
                <th colSpan={8} style={{ border: "unset !important" }}>
                  Section A: Personal Data
                </th>
              </tr>
              <tr>
                <th></th>
                <th style={{ verticalAlign: "middle" }} className="text-center">
                  First Name
                </th>
                <th style={{ verticalAlign: "middle" }} className="text-center">
                  Last Name
                </th>
                <th style={{ verticalAlign: "middle" }} className="text-center">
                  DOB
                </th>
                <th style={{ verticalAlign: "middle" }} className="text-center">
                  Address
                </th>
                <th style={{ verticalAlign: "middle" }} className="text-center">
                  City
                </th>
                <th style={{ verticalAlign: "middle" }} className="text-center">
                  State
                </th>
                <th style={{ verticalAlign: "middle" }} className="text-center">
                  Zip
                </th>
              </tr>
              <tr>
                <th>Employee:</th>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="firstname"
                    value={formData.firstname || ""}
                    className="text-center"
                    disabled={true}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="lastname"
                    value={formData.lastname || ""}
                    className="text-center"
                    disabled={true}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="date"
                    placeholder=""
                    name="dob"
                    className="text-center"
                    value={
                      formData.dob
                        ? moment(formData.dob).format("YYYY-MM-DD")
                        : ""
                    }
                    disabled={true}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="address"
                    value={formData.address || ""}
                    className="text-center"
                    onChange={(e) =>
                      handleStateByField("address", e.target.value)
                    }
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="city"
                    className="text-center"
                    value={formData.city || ""}
                    onChange={(e) => handleStateByField("city", e.target.value)}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="state"
                    className="text-center"
                    value={formData.state || ""}
                    disabled={true}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="zip"
                    className="text-center"
                    value={formData.zip || ""}
                    onChange={(e) => handleStateByField("zip", e.target.value)}
                  />
                </td>
              </tr>
              <tr>
                <th>Spouse:</th>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="spouse_firstname"
                    value={formData.spouse_firstname || ""}
                    className="text-center"
                    disabled={true}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="spouse_lastname"
                    className="text-center"
                    value={formData.spouse_lastname || ""}
                    disabled={true}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="date"
                    placeholder=""
                    name="spouse_dob"
                    value={
                      formData.spouse_dob
                        ? moment(formData.spouse_dob).format("YYYY-MM-DD")
                        : ""
                    }
                    className="text-center"
                    disabled={true}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="spouse_address"
                    value={formData.spouse_address || ""}
                    className="text-center"
                    onChange={(e) =>
                      handleStateByField("spouse_address", e.target.value)
                    }
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="spouse_city"
                    value={formData.spouse_city || ""}
                    className="text-center"
                    onChange={(e) =>
                      handleStateByField("spouse_city", e.target.value)
                    }
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="spouse_state"
                    value={formData.state || ""}
                    className="text-center"
                    disabled={true}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="spouse_zip"
                    value={formData.spouse_zip || ""}
                    className="text-center"
                    onChange={(e) =>
                      handleStateByField("spouse_zip", e.target.value)
                    }
                  />
                </td>
              </tr>
            </tbody>
          </Table>
          <Table className="m-3 table-content table-two" responsive="md">
            <tbody>
              <tr>
                <th colSpan={5} style={{ border: "unset !important" }}>
                  Section B: Contact Information
                </th>
              </tr>
              <tr>
                <th style={{ verticalAlign: "middle" }} className="text-center">
                  Home Phone
                </th>
                <th style={{ verticalAlign: "middle" }} className="text-center">
                  Office Phone
                </th>
                <th style={{ verticalAlign: "middle" }} className="text-center">
                  Cell/Other
                </th>
                <th style={{ verticalAlign: "middle" }} className="text-center">
                  Fax
                </th>
                <th style={{ verticalAlign: "middle" }} className="text-center">
                  Email Address
                </th>
              </tr>
              <tr>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="home_phone"
                    value={formData.home_phone || ""}
                    className="text-center"
                    onChange={(e) =>
                      handleStateByField("home_phone", e.target.value)
                    }
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="office_phone"
                    value={formData.office_phone || ""}
                    className="text-center"
                    onChange={(e) =>
                      handleStateByField("office_phone", e.target.value)
                    }
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="mobile_phone"
                    value={formData.mobile_phone || ""}
                    className="text-center"
                    disabled={true}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="fax"
                    value={formData.fax || ""}
                    className="text-center"
                    onChange={(e) => handleStateByField("fax", e.target.value)}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="email"
                    placeholder=""
                    name="toEmail"
                    value={formData.toEmail || ""}
                    className="text-center"
                    disabled={true}
                  />
                </td>
              </tr>
            </tbody>
          </Table>
          <Table className="m-3 table-content table-three" responsive="md">
            <tbody>
              <tr>
                <th colSpan={5} style={{ border: "unset !important" }}>
                  Section C: Children & Grandchildren
                </th>
              </tr>
              <tr>
                <th style={{ verticalAlign: "middle" }} className="text-center">
                  First Name
                </th>
                <th style={{ verticalAlign: "middle" }} className="text-center">
                  Last Name
                </th>
                <th style={{ verticalAlign: "middle" }} className="text-center">
                  DOB
                </th>
                <th style={{ verticalAlign: "middle" }} className="text-center">
                  Child / GC
                </th>
                <th style={{ verticalAlign: "middle" }} className="text-center">
                  City
                </th>
                <th style={{ verticalAlign: "middle" }} className="text-center">
                  State
                </th>
              </tr>
              <tr>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="children_firstname"
                    value={formData.children_firstname || ""}
                    className="text-center"
                    onChange={(e) =>
                      handleStateByField("children_firstname", e.target.value)
                    }
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="children_lastname"
                    value={formData.children_lastname || ""}
                    className="text-center"
                    onChange={(e) =>
                      handleStateByField("children_lastname", e.target.value)
                    }
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="date"
                    placeholder=""
                    name="children_dob"
                    value={
                      formData.children_dob
                        ? moment(formData.children_dob).format("YYYY-MM-DD")
                        : ""
                    }
                    className="text-center"
                    onChange={(e) =>
                      handleStateByField("children_dob", e.target.value)
                    }
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="children_relation"
                    value={formData.children_relation || ""}
                    className="text-center"
                    onChange={(e) =>
                      handleStateByField("children_relation", e.target.value)
                    }
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="children_city"
                    value={formData.children_city || ""}
                    className="text-center"
                    onChange={(e) =>
                      handleStateByField("children_city", e.target.value)
                    }
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="children_state"
                    value={formData.children_state || ""}
                    className="text-center"
                    onChange={(e) =>
                      handleStateByField("children_state", e.target.value)
                    }
                  />
                </td>
              </tr>
              <tr>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="grandchildren_firstname"
                    value={formData.grandchildren_firstname || ""}
                    className="text-center"
                    onChange={(e) =>
                      handleStateByField(
                        "grandchildren_firstname",
                        e.target.value
                      )
                    }
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="grandchildren_lastname"
                    value={formData.grandchildren_lastname || ""}
                    className="text-center"
                    onChange={(e) =>
                      handleStateByField(
                        "grandchildren_lastname",
                        e.target.value
                      )
                    }
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="date"
                    placeholder=""
                    name="grandchildren_dob"
                    value={
                      formData.grandchildren_dob
                        ? moment(formData.grandchildren_dob).format(
                            "YYYY-MM-DD"
                          )
                        : ""
                    }
                    className="text-center"
                    onChange={(e) =>
                      handleStateByField("grandchildren_dob", e.target.value)
                    }
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="grandchildren_relation"
                    value={formData.grandchildren_relation || ""}
                    className="text-center"
                    onChange={(e) =>
                      handleStateByField(
                        "grandchildren_relation",
                        e.target.value
                      )
                    }
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="grandchildren_city"
                    value={formData.grandchildren_city || ""}
                    className="text-center"
                    onChange={(e) =>
                      handleStateByField("grandchildren_city", e.target.value)
                    }
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="grandchildren_state"
                    value={formData.grandchildren_state || ""}
                    className="text-center"
                    onChange={(e) =>
                      handleStateByField("grandchildren_state", e.target.value)
                    }
                  />
                </td>
              </tr>
            </tbody>
          </Table>
          <Table className="m-3 table-content table-four" responsive="md">
            <tbody>
              <tr>
                <th colSpan={5} style={{ border: "unset !important" }}>
                  Section D: Financial Information
                </th>
              </tr>
              <tr>
                <th style={{ verticalAlign: "middle" }} className="text-center">
                  Client / Spouse
                </th>
                <th
                  style={{ verticalAlign: "middle" }}
                  className="text-center"
                  colSpan={2}
                >
                  Currently Working
                </th>
                <th style={{ verticalAlign: "middle" }} className="text-center">
                  Annual Income
                </th>
                <th style={{ verticalAlign: "middle" }} className="text-center">
                  Other Income
                </th>
              </tr>
              <tr>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder="Client"
                    name=""
                    value={"Client"}
                    className="text-center"
                    disabled={true}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    as="select"
                    name="currently_working"
                    className="text-center"
                    defaultValue=""
                    onChange={(e) =>
                      handleStateByField("currently_working", e.target.value)
                    }
                  >
                    <option
                      value="Yes"
                      selected={formData.currently_working === "Yes"}
                    >
                      Yes
                    </option>
                    <option
                      value="No"
                      selected={formData.currently_working === "Yes"}
                    >
                      No
                    </option>
                  </Form.Control>
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder="If Yes, how much longer:"
                    name="working_duration"
                    className="text-center"
                    value={formData.working_duration || ""}
                    onChange={(e) =>
                      handleStateByField("working_duration", e.target.value)
                    }
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="pay_s2_1"
                    value={
                      formData.pay_s2_1
                        ? "$" + formatValue(formData.pay_s2_1)
                        : ""
                    }
                    className="text-center"
                    disabled={true}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="additional_sources_of_income_at_retire_other_income_amount"
                    value={
                      formData.additional_sources_of_income_at_retire_other_income_amount
                        ? "$" +
                          formatValue(
                            formData.additional_sources_of_income_at_retire_other_income_amount
                          )
                        : ""
                    }
                    className="text-center"
                    disabled={true}
                  />
                </td>
              </tr>
              <tr>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder="Spouse"
                    name=""
                    value={"Spouse"}
                    className="text-center"
                    disabled={true}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    as="select"
                    name="spouse_currently_working"
                    className="text-center"
                    defaultValue=""
                    onChange={(e) =>
                      handleStateByField(
                        "spouse_currently_working",
                        e.target.value
                      )
                    }
                  >
                    <option
                      value="Yes"
                      selected={formData.spouse_currently_working === "Yes"}
                    >
                      Yes
                    </option>
                    <option
                      value="No"
                      selected={formData.spouse_currently_working === "No"}
                    >
                      No
                    </option>
                  </Form.Control>
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder="If Yes, how much longer:"
                    name="spouse_working_duration"
                    value={formData.spouse_working_duration || ""}
                    className="text-center"
                    onChange={(e) =>
                      handleStateByField(
                        "spouse_working_duration",
                        e.target.value
                      )
                    }
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="s2s6_spouse_employed_annual_income"
                    value={
                      formData.s2s6_spouse_employed_annual_income
                        ? "$" +
                          formatValue(
                            formData.s2s6_spouse_employed_annual_income
                          )
                        : ""
                    }
                    className="text-center"
                    disabled={true}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="spouse_additional_sources_of_income_at_retire_other_income_amount"
                    className="text-center"
                    value={
                      formData.spouse_additional_sources_of_income_at_retire_other_income_amount
                        ? "$" +
                          formatValue(
                            formData.spouse_additional_sources_of_income_at_retire_other_income_amount
                          )
                        : ""
                    }
                    disabled={true}
                  />
                </td>
              </tr>
            </tbody>
          </Table>
          <div className="row">
            <div className="col-md-6 px-0">
              <Table className="m-3 table-content table-five" responsive="md">
                <tbody>
                  <tr>
                    <th colSpan={5} style={{ border: "unset !important" }}>
                      Section E: Real Estate
                    </th>
                  </tr>
                  <tr>
                    <th
                      style={{ verticalAlign: "middle" }}
                      className="text-center"
                    >
                      Location
                    </th>
                    <th
                      style={{ verticalAlign: "middle" }}
                      className="text-center"
                    >
                      Value
                    </th>
                    <th
                      style={{ verticalAlign: "middle" }}
                      className="text-center"
                    >
                      Mortgage / Income Property
                    </th>
                    <th
                      style={{ verticalAlign: "middle" }}
                      className="text-center"
                    >
                      Monthly Income
                    </th>
                  </tr>
                  <tr>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="client_property_location"
                        value={formData.client_property_location || ""}
                        className="text-center"
                        onChange={(e) =>
                          handleStateByField(
                            "client_property_location",
                            e.target.value
                          )
                        }
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="client_property_value"
                        value={formData.client_property_value || ""}
                        className="text-center"
                        onChange={(e) =>
                          handleStateByField(
                            "client_property_value",
                            e.target.value
                          )
                        }
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="client_property_mortgage_or_income_property"
                        value={
                          formData.client_property_mortgage_or_income_property ||
                          ""
                        }
                        className="text-center"
                        onChange={(e) =>
                          handleStateByField(
                            "client_property_mortgage_or_income_property",
                            e.target.value
                          )
                        }
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="client_property_monthly_income"
                        value={formData.client_property_monthly_income || ""}
                        className="text-center"
                        onChange={(e) =>
                          handleStateByField(
                            "client_property_monthly_income",
                            e.target.value
                          )
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="spouse_property_location"
                        value={formData.spouse_property_location || ""}
                        className="text-center"
                        onChange={(e) =>
                          handleStateByField(
                            "spouse_property_location",
                            e.target.value
                          )
                        }
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="spouse_property_value"
                        value={formData.spouse_property_value || ""}
                        className="text-center"
                        onChange={(e) =>
                          handleStateByField(
                            "spouse_property_value",
                            e.target.value
                          )
                        }
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="spouse_property_mortgage_or_income_property"
                        value={
                          formData.spouse_property_mortgage_or_income_property ||
                          ""
                        }
                        className="text-center"
                        onChange={(e) =>
                          handleStateByField(
                            "spouse_property_mortgage_or_income_property",
                            e.target.value
                          )
                        }
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="spouse_property_monthly_income"
                        value={formData.spouse_property_monthly_income || ""}
                        className="text-center"
                        onChange={(e) =>
                          handleStateByField(
                            "spouse_property_monthly_income",
                            e.target.value
                          )
                        }
                      />
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
            <div className="col-md-6 px-0">
              <Table className="m-3 table-content table-six" responsive="md">
                <tbody>
                  <tr>
                    <th colSpan={5} style={{ border: "unset !important" }}>
                      Section F: Cash Reserves
                    </th>
                  </tr>
                  <tr>
                    <th
                      style={{ verticalAlign: "middle" }}
                      className="text-center"
                    >
                      Institution Name
                    </th>
                    <th
                      style={{ verticalAlign: "middle" }}
                      className="text-center"
                    >
                      Account Type
                    </th>
                    <th
                      style={{ verticalAlign: "middle" }}
                      className="text-center"
                    >
                      Current Balance
                    </th>
                    <th
                      style={{ verticalAlign: "middle" }}
                      className="text-center"
                    >
                      Maturity Date
                    </th>
                    <th
                      style={{ verticalAlign: "middle" }}
                      className="text-center"
                    >
                      Interest Rate
                    </th>
                  </tr>
                  {formData.s14_balance && Array.isArray(formData.s14_balance)
                    ? formData.s14_balance.map((data, index) => (
                        <tr>
                          <td
                            className={"highlightNumber"}
                            style={{ padding: "0px 2px" }}
                          >
                            <Form.Control
                              autoComplete="off"
                              type="text"
                              placeholder=""
                              name=""
                              value={formData.s14_institution_name[index] || ""}
                              className="text-center"
                              disabled={true}
                            />
                          </td>
                          <td
                            className={"highlightNumber"}
                            style={{ padding: "0px 2px" }}
                          >
                            <Form.Control
                              as="select"
                              type="text"
                              name=""
                              value={
                                formData.s14_account_type &&
                                formData.s14_account_type[index]
                              }
                              disabled={true}
                              readOnly={true}
                            >
                              <option></option>
                              <option value="Checking">Checking</option>
                              <option value="Savings">Savings</option>
                              <option value="Money_Market">Money Market</option>
                              <option value="other">other</option>
                            </Form.Control>
                          </td>
                          <td
                            className={"highlightNumber"}
                            style={{ padding: "0px 2px" }}
                          >
                            <Form.Control
                              autoComplete="off"
                              type="text"
                              placeholder=""
                              name=""
                              value={
                                formData.s14_balance[index]
                                  ? "$" +
                                    formatValue(formData.s14_balance[index])
                                  : ""
                              }
                              className="text-center"
                              disabled={true}
                            />
                          </td>
                          <td
                            className={"highlightNumber"}
                            style={{ padding: "0px 2px" }}
                          >
                            <Form.Control
                              autoComplete="off"
                              type="date"
                              placeholder=""
                              name=""
                              value={
                                formData.s14_maturity_date
                                  ? parseIfNeeded(formData.s14_maturity_date)[
                                      index
                                    ]
                                  : ""
                              }
                              className="text-center"
                              onChange={(e) =>
                                handleMaturityDate(index, e.target.value)
                              }
                            />
                          </td>
                          <td
                            className={"highlightNumber"}
                            style={{ padding: "0px 2px" }}
                          >
                            <Form.Control
                              autoComplete="off"
                              type="text"
                              placeholder=""
                              name="s14_interest_rate"
                              value={
                                formData.s14_interest_rate
                                  ? parseIfNeeded(formData.s14_interest_rate)[
                                      index
                                    ]
                                  : ""
                              }
                              className="text-center"
                              onChange={(e) =>
                                handleInterestRate(index, e.target.value)
                              }
                            />
                          </td>
                        </tr>
                      ))
                    : ""}
                  <tr>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="s14_institution_name_n"
                        value={formData.s14_institution_name_n || ""}
                        className="text-center"
                        onChange={(e) =>
                          handleStateByField(
                            "s14_institution_name_n",
                            e.target.value
                          )
                        }
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        as="select"
                        type="text"
                        name="s14_account_type_n"
                        value={formData.s14_account_type_n || ""}
                        onChange={(e) =>
                          handleStateByField(
                            "s14_account_type_n",
                            e.target.value
                          )
                        }
                      >
                        <option></option>
                        <option
                          value="Checking"
                          selected={formData.s14_account_type_n == "Checking"}
                        >
                          Checking
                        </option>
                        <option
                          value="Savings"
                          selected={formData.s14_account_type_n == "Savings"}
                        >
                          Savings
                        </option>
                        <option
                          value="Money_Market"
                          selected={
                            formData.s14_account_type_n == "Money_Market"
                          }
                        >
                          Money Market
                        </option>
                        <option
                          value="Other"
                          selected={formData.s14_account_type_n == "Other"}
                        >
                          Other
                        </option>
                      </Form.Control>
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="s14_balance_n"
                        value={
                          formData.s14_balance_n
                            ? "$" +
                              formatValue(convertValue(formData.s14_balance_n))
                            : ""
                        }
                        className="text-center"
                        onChange={(e) =>
                          handleStateByField("s14_balance_n", e.target.value)
                        }
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="date"
                        placeholder=""
                        name="maturity_date_n"
                        value={formData.maturity_date_n || ""}
                        className="text-center"
                        onChange={(e) =>
                          handleStateByField("maturity_date_n", e.target.value)
                        }
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="interest_rate_n"
                        value={formData.interest_rate_n || ""}
                        className="text-center"
                        onChange={(e) =>
                          handleStateByField("interest_rate_n", e.target.value)
                        }
                      />
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>
          <div className="row">
            <div className="col-md-8 px-0">
              <Table className="m-3 table-content table-seven" responsive="md">
                <tbody>
                  <tr>
                    <th colSpan={5} style={{ border: "unset !important" }}>
                      Section G: Other Investments & Insurance Products
                    </th>
                  </tr>
                  <tr>
                    <th
                      style={{ verticalAlign: "middle" }}
                      className="text-center"
                    >
                      Institution/Insurer
                    </th>
                    <th
                      style={{ verticalAlign: "middle" }}
                      className="text-center"
                    >
                      Account Type
                    </th>
                    <th
                      style={{ verticalAlign: "middle" }}
                      className="text-center"
                    >
                      Current Balance
                    </th>
                    <th
                      style={{ verticalAlign: "middle" }}
                      className="text-center"
                    >
                      Contribution $ / %
                    </th>
                    <th
                      style={{ verticalAlign: "middle" }}
                      className="text-center"
                    >
                      Interest Rate
                    </th>
                  </tr>
                  <tr>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        className="text-center"
                        value={"Thrift Savings Plan"}
                        disabled={true}
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        className="text-center"
                        value={"TSP"}
                        disabled={true}
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        className="text-center"
                        disabled={true}
                        value={
                          formData.screen12_balance_of_traditional_tsp +
                          formData.screen12_balance_of_roth_tsp
                            ? "$" +
                              formatValue(
                                convertValue(
                                  formData.screen12_balance_of_traditional_tsp
                                ) +
                                  convertValue(
                                    formData.screen12_balance_of_roth_tsp
                                  )
                              )
                            : ""
                        }
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        className="text-center"
                        name="tsp_contribution"
                        value={formData.tsp_contribution || ""}
                        onChange={(e) =>
                          handleStateByField("tsp_contribution", e.target.value)
                        }
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="tsp_interest_rate"
                        className="text-center"
                        value={formData.tsp_interest_rate || ""}
                        onChange={(e) =>
                          handleStateByField(
                            "tsp_interest_rate",
                            e.target.value
                          )
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="fp_field_1_a"
                        className="text-center"
                        value={formData.fp_field_1_a || ""}
                        onChange={(e) =>
                          handleStateByField("fp_field_1_a", e.target.value)
                        }
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="fp_field_2_a"
                        className="text-center"
                        value={"403B"}
                        disabled={true}
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="fp_field_3_a"
                        className="text-center"
                        value={formData.fp_field_3_a || ""}
                        onChange={(e) =>
                          handleStateByField("fp_field_3_a", e.target.value)
                        }
                        onBlur={(event) =>
                          handleBlurFP(event, true, setformData)
                        }
                        onFocus={(event) => handleFocusFP(event, setformData)}
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="fp_field_4_a"
                        className="text-center"
                        value={formData.fp_field_4_a || ""}
                        onChange={(e) =>
                          handleStateByField("fp_field_4_a", e.target.value)
                        }
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="fp_field_5_a"
                        className="text-center"
                        value={formData.fp_field_5_a || ""}
                        onChange={(e) =>
                          handleStateByField("fp_field_5_a", e.target.value)
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="fp_field_1_b"
                        className="text-center"
                        value={formData.fp_field_1_b || ""}
                        onChange={(e) =>
                          handleStateByField("fp_field_1_b", e.target.value)
                        }
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="fp_field_2_b"
                        className="text-center"
                        value={"Roth IRA"}
                        disabled={true}
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="fp_field_3_b"
                        className="text-center"
                        value={formData.fp_field_3_b || ""}
                        onChange={(e) =>
                          handleStateByField("fp_field_3_b", e.target.value)
                        }
                        onBlur={(event) =>
                          handleBlurFP(event, true, setformData)
                        }
                        onFocus={(event) => handleFocusFP(event, setformData)}
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="fp_field_4_b"
                        className="text-center"
                        value={formData.fp_field_4_b || ""}
                        onChange={(e) =>
                          handleStateByField("fp_field_4_b", e.target.value)
                        }
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="fp_field_5_b"
                        className="text-center"
                        value={formData.fp_field_5_b || ""}
                        onChange={(e) =>
                          handleStateByField("fp_field_5_b", e.target.value)
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="fp_field_1_c"
                        className="text-center"
                        value={formData.fp_field_1_c || ""}
                        onChange={(e) =>
                          handleStateByField("fp_field_1_c", e.target.value)
                        }
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="fp_field_2_c"
                        className="text-center"
                        value={"IRA's"}
                        disabled={true}
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="fp_field_3_c"
                        className="text-center"
                        value={formData.fp_field_3_c || ""}
                        onChange={(e) =>
                          handleStateByField("fp_field_3_c", e.target.value)
                        }
                        onBlur={(event) =>
                          handleBlurFP(event, true, setformData)
                        }
                        onFocus={(event) => handleFocusFP(event, setformData)}
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="fp_field_4_c"
                        className="text-center"
                        value={formData.fp_field_4_c || ""}
                        onChange={(e) =>
                          handleStateByField("fp_field_4_c", e.target.value)
                        }
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="fp_field_5_c"
                        className="text-center"
                        value={formData.fp_field_5_c || ""}
                        onChange={(e) =>
                          handleStateByField("fp_field_5_c", e.target.value)
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="fp_field_1_d"
                        className="text-center"
                        value={formData.fp_field_1_d || ""}
                        onChange={(e) =>
                          handleStateByField("fp_field_1_d", e.target.value)
                        }
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="fp_field_2_d"
                        className="text-center"
                        value={"Fixed Annuities"}
                        disabled={true}
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="fp_field_3_d"
                        className="text-center"
                        value={formData.fp_field_3_d || ""}
                        onChange={(e) =>
                          handleStateByField("fp_field_3_d", e.target.value)
                        }
                        onBlur={(event) =>
                          handleBlurFP(event, true, setformData)
                        }
                        onFocus={(event) => handleFocusFP(event, setformData)}
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="fp_field_4_d"
                        className="text-center"
                        value={formData.fp_field_4_d || ""}
                        onChange={(e) =>
                          handleStateByField("fp_field_4_d", e.target.value)
                        }
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="fp_field_5_d"
                        className="text-center"
                        value={formData.fp_field_5_d || ""}
                        onChange={(e) =>
                          handleStateByField("fp_field_5_d", e.target.value)
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="fp_field_1_e"
                        className="text-center"
                        value={formData.fp_field_1_e || ""}
                        onChange={(e) =>
                          handleStateByField("fp_field_1_e", e.target.value)
                        }
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="fp_field_2_e"
                        className="text-center"
                        value={"LTC Insurance"}
                        disabled={true}
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="fp_field_3_e"
                        className="text-center"
                        value={formData.fp_field_3_e || ""}
                        onChange={(e) =>
                          handleStateByField("fp_field_3_e", e.target.value)
                        }
                        onBlur={(event) =>
                          handleBlurFP(event, true, setformData)
                        }
                        onFocus={(event) => handleFocusFP(event, setformData)}
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="fp_field_4_e"
                        className="text-center"
                        value={formData.fp_field_4_e || ""}
                        onChange={(e) =>
                          handleStateByField("fp_field_4_e", e.target.value)
                        }
                        onBlur={(event) =>
                          handleBlurFP(event, true, setformData)
                        }
                        onFocus={(event) => handleFocusFP(event, setformData)}
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="fp_field_5_e"
                        className="text-center"
                        value={formData.fp_field_5_e || ""}
                        onChange={(e) =>
                          handleStateByField("fp_field_5_e", e.target.value)
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="fp_field_1_f"
                        className="text-center"
                        value={formData.fp_field_1_f || ""}
                        onChange={(e) =>
                          handleStateByField("fp_field_1_f", e.target.value)
                        }
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="fp_field_2_f"
                        className="text-center"
                        value={"Life Insurance"}
                        disabled={true}
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="fp_field_3_f"
                        className="text-center"
                        value={formData.fp_field_3_f || ""}
                        onChange={(e) =>
                          handleStateByField("fp_field_3_f", e.target.value)
                        }
                        onBlur={(event) =>
                          handleBlurFP(event, true, setformData)
                        }
                        onFocus={(event) => handleFocusFP(event, setformData)}
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="fp_field_4_f"
                        className="text-center"
                        value={formData.fp_field_4_f || ""}
                        onChange={(e) =>
                          handleStateByField("fp_field_4_f", e.target.value)
                        }
                      />
                    </td>
                    <td
                      className={"highlightNumber"}
                      style={{ padding: "0px 2px" }}
                    >
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="fp_field_5_f"
                        className="text-center"
                        value={formData.fp_field_5_f || ""}
                        onChange={(e) =>
                          handleStateByField("fp_field_5_f", e.target.value)
                        }
                      />
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>
          <Table className="m-3 table-content table-nine" responsive="md">
            <tbody>
              <tr>
                <th colSpan={5} style={{ border: "unset !important" }}>
                  Section H: Retirement Income Needs
                </th>
              </tr>
              <tr>
                <th style={{ verticalAlign: "middle" }} className="text-center">
                  Income Needs
                </th>
                <th style={{ verticalAlign: "middle" }} className="text-center">
                  Client
                </th>
                <th style={{ verticalAlign: "middle" }} className="text-center">
                  Spouse
                </th>
                <th style={{ verticalAlign: "middle" }} className="text-center">
                  Before-Tax Total:
                </th>
                <th style={{ verticalAlign: "middle" }} className="text-center">
                  After-Tax Total:
                </th>
              </tr>
              <tr>
                <td>Desired Retirement Age</td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="desired_retirement_date"
                    value={formData.MRA ? parseInt(formData.MRA) : null}
                    className="text-center"
                    disabled={true}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="spouse_desired_retirement_age"
                    className="text-center"
                    onChange={(e) =>
                      handleStateByField(
                        "spouse_desired_retirement_age",
                        e.target.value
                      )
                    }
                    value={formData.spouse_desired_retirement_age}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                ></td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                ></td>
              </tr>
              <tr>
                <td>
                  Monthly Household Income <strong>TODAY</strong>
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="monthly_household_income_today_client"
                    className="text-center"
                    value={
                      formData.pay_s2_36
                        ? "$" +
                          formatValue(
                            (convertValue(formData.pay_s2_36) * 26) / 12
                          )
                        : ""
                    }
                    disabled={true}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="monthly_household_income_today_spouse"
                    value={formData.monthly_household_income_today_spouse || ""}
                    onChange={(e) =>
                      handleStateByField(
                        "monthly_household_income_today_spouse",
                        e.target.value
                      )
                    }
                    onBlur={(event) => handleBlurFP(event, true, setformData)}
                    onFocus={(event) => handleFocusFP(event, setformData)}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="monthly_household_income_today_before_tax_total"
                    className="text-center"
                    value={
                      formData.monthly_household_income_today_before_tax_total ||
                      ""
                    }
                    onChange={(e) =>
                      handleStateByField(
                        "monthly_household_income_today_before_tax_total",
                        e.target.value
                      )
                    }
                    onBlur={(event) => handleBlurFP(event, true, setformData)}
                    onFocus={(event) => handleFocusFP(event, setformData)}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="monthly_household_income_today_after_tax_total"
                    className="text-center"
                    value={
                      formData.monthly_household_income_today_after_tax_total ||
                      ""
                    }
                    onChange={(e) =>
                      handleStateByField(
                        "monthly_household_income_today_after_tax_total",
                        e.target.value
                      )
                    }
                    onBlur={(event) => handleBlurFP(event, true, setformData)}
                    onFocus={(event) => handleFocusFP(event, setformData)}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  Monthly Household Expenses <strong>TODAY</strong>
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="monthly_household_expenses_today_client"
                    className="text-center"
                    value={
                      formData.monthly_household_expenses_today_client || ""
                    }
                    onChange={(e) =>
                      handleStateByField(
                        "monthly_household_expenses_today_client",
                        e.target.value
                      )
                    }
                    onBlur={(event) => handleBlurFP(event, true, setformData)}
                    onFocus={(event) => handleFocusFP(event, setformData)}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="monthly_household_expenses_today_spouse"
                    className="text-center"
                    onChange={(e) =>
                      handleStateByField(
                        "monthly_household_expenses_today_spouse",
                        e.target.value
                      )
                    }
                    onBlur={(event) => handleBlurFP(event, true, setformData)}
                    onFocus={(event) => handleFocusFP(event, setformData)}
                    value={
                      formData.monthly_household_expenses_today_spouse || ""
                    }
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="monthly_household_expenses_today_before_tax_total"
                    className="text-center"
                    onChange={(e) =>
                      handleStateByField(
                        "monthly_household_expenses_today_before_tax_total",
                        e.target.value
                      )
                    }
                    onBlur={(event) => handleBlurFP(event, true, setformData)}
                    onFocus={(event) => handleFocusFP(event, setformData)}
                    value={
                      formData.monthly_household_expenses_today_before_tax_total ||
                      ""
                    }
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="monthly_household_expenses_today_after_tax_total"
                    className="text-center"
                    onChange={(e) =>
                      handleStateByField(
                        "monthly_household_expenses_today_after_tax_total",
                        e.target.value
                      )
                    }
                    onBlur={(event) => handleBlurFP(event, true, setformData)}
                    onFocus={(event) => handleFocusFP(event, setformData)}
                    value={
                      formData.monthly_household_expenses_today_after_tax_total ||
                      ""
                    }
                  />
                </td>
              </tr>
              <tr>
                <td>Monthly Income Needed at Retirement</td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="monthly_income_needed_at_retirement_client"
                    className="text-center"
                    onChange={(e) =>
                      handleStateByField(
                        "monthly_income_needed_at_retirement_client",
                        e.target.value
                      )
                    }
                    value={
                      formData.monthly_income_needed_at_retirement_client || ""
                    }
                    onBlur={(event) => handleBlurFP(event, true, setformData)}
                    onFocus={(event) => handleFocusFP(event, setformData)}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="monthly_income_needed_at_retirement_spouse"
                    className="text-center"
                    onChange={(e) =>
                      handleStateByField(
                        "monthly_income_needed_at_retirement_spouse",
                        e.target.value
                      )
                    }
                    value={
                      formData.monthly_income_needed_at_retirement_spouse || ""
                    }
                    onBlur={(event) => handleBlurFP(event, true, setformData)}
                    onFocus={(event) => handleFocusFP(event, setformData)}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="monthly_income_needed_at_retirement_total_before_tax"
                    className="text-center"
                    onChange={(e) =>
                      handleStateByField(
                        "monthly_income_needed_at_retirement_total_before_tax",
                        e.target.value
                      )
                    }
                    value={
                      formData.monthly_income_needed_at_retirement_total_before_tax ||
                      ""
                    }
                    onBlur={(event) => handleBlurFP(event, true, setformData)}
                    onFocus={(event) => handleFocusFP(event, setformData)}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="monthly_income_needed_at_retirement_total_after_tax"
                    className="text-center"
                    onChange={(e) =>
                      handleStateByField(
                        "monthly_income_needed_at_retirement_total_after_tax",
                        e.target.value
                      )
                    }
                    value={
                      formData.monthly_income_needed_at_retirement_total_after_tax ||
                      ""
                    }
                    onBlur={(event) => handleBlurFP(event, true, setformData)}
                    onFocus={(event) => handleFocusFP(event, setformData)}
                  />
                </td>
              </tr>
              <tr>
                <td>Monthly Pension at Retirement</td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="monthly_pension_at_retirement_client"
                    className="text-center"
                    value={
                      formData.reduced_monthly_income
                        ? "$" + formatValue(formData.reduced_monthly_income)
                        : ""
                    }
                    disabled={true}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="monthly_pension_at_retirement_spouse"
                    className="text-center"
                    value={
                      formData.s2s6_spouse_employed_est_monthly_pension
                        ? "$" +
                          formatValue(
                            formData.s2s6_spouse_employed_est_monthly_pension
                          )
                        : ""
                    }
                    disabled={true}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="monthly_pension_at_retirement_before_tax_total"
                    className="text-center"
                    onChange={(e) =>
                      handleStateByField(
                        "monthly_pension_at_retirement_before_tax_total",
                        e.target.value
                      )
                    }
                    value={
                      formData.monthly_pension_at_retirement_before_tax_total ||
                      ""
                    }
                    onBlur={(event) => handleBlurFP(event, true, setformData)}
                    onFocus={(event) => handleFocusFP(event, setformData)}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="monthly_pension_at_retirement_after_tax_total"
                    className="text-center"
                    onChange={(e) =>
                      handleStateByField(
                        "monthly_pension_at_retirement_after_tax_total",
                        e.target.value
                      )
                    }
                    onBlur={(event) => handleBlurFP(event, true, setformData)}
                    onFocus={(event) => handleFocusFP(event, setformData)}
                    value={
                      formData.monthly_pension_at_retirement_after_tax_total ||
                      ""
                    }
                  />
                </td>
              </tr>
              <tr>
                <td>Monthly Social Security at Retirement</td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="monthly_social_security_at_retirement_client"
                    className="text-center"
                    value={
                      formData.age_62_ss_benefit_final
                        ? "$" + formatValue(formData.age_62_ss_benefit_final)
                        : ""
                    }
                    disabled={true}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="monthly_social_security_at_retirement_spouse"
                    className="text-center"
                    value={
                      formData.s2s6_spouse_employed_est_mon_soc_sec_inc
                        ? "$" +
                          formatValue(
                            formData.s2s6_spouse_employed_est_mon_soc_sec_inc
                          )
                        : ""
                    }
                    disabled={true}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="monthly_social_security_at_retirement_before_tax_total"
                    className="text-center"
                    onChange={(e) =>
                      handleStateByField(
                        "monthly_social_security_at_retirement_before_tax_total",
                        e.target.value
                      )
                    }
                    onBlur={(event) => handleBlurFP(event, true, setformData)}
                    onFocus={(event) => handleFocusFP(event, setformData)}
                    value={
                      formData.monthly_social_security_at_retirement_before_tax_total
                    }
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="monthly_social_security_at_retirement_after_tax_total"
                    className="text-center"
                    onChange={(e) =>
                      handleStateByField(
                        "monthly_social_security_at_retirement_after_tax_total",
                        e.target.value
                      )
                    }
                    onBlur={(event) => handleBlurFP(event, true, setformData)}
                    onFocus={(event) => handleFocusFP(event, setformData)}
                    value={
                      formData.monthly_social_security_at_retirement_after_tax_total
                    }
                  />
                </td>
              </tr>
              <tr>
                <td>Monthly Other Income at Retirement</td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="monthly_other_income_at_retirement_client"
                    className="text-center"
                    value={
                      formData.additional_sources_of_income_at_retire_other_income_amount
                        ? "$" +
                          formatValue(
                            formData.additional_sources_of_income_at_retire_other_income_amount
                          )
                        : ""
                    }
                    disabled={true}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="monthly_other_income_at_retirement_spouse"
                    className="text-center"
                    value={
                      formData.s2s6_spouse_employed_est_monthly_other_income
                        ? "$" +
                          formatValue(
                            formData.s2s6_spouse_employed_est_monthly_other_income
                          )
                        : ""
                    }
                    disabled={true}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="monthly_other_income_at_retirement_before_tax_total"
                    className="text-center"
                    onChange={(e) =>
                      handleStateByField(
                        "monthly_other_income_at_retirement_before_tax_total",
                        e.target.value
                      )
                    }
                    value={
                      formData.monthly_other_income_at_retirement_before_tax_total ||
                      ""
                    }
                    onBlur={(event) => handleBlurFP(event, true, setformData)}
                    onFocus={(event) => handleFocusFP(event, setformData)}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="monthly_other_income_at_retirement_after_tax_total"
                    className="text-center"
                    value={
                      formData.monthly_other_income_at_retirement_after_tax_total ||
                      ""
                    }
                    onChange={(e) =>
                      handleStateByField(
                        "monthly_other_income_at_retirement_after_tax_total",
                        e.target.value
                      )
                    }
                    onBlur={(event) => handleBlurFP(event, true, setformData)}
                    onFocus={(event) => handleFocusFP(event, setformData)}
                  />
                </td>
              </tr>
              <tr>
                <td>Total: (Income Gap or Income Gain)</td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="total_income_gap_or_income_gain_client"
                    className="text-center"
                    value={
                      formData.total_income_gap_or_income_gain_client || ""
                    }
                    onBlur={(event) => handleBlurFP(event, true, setformData)}
                    onFocus={(event) => handleFocusFP(event, setformData)}
                    onChange={(e) =>
                      handleStateByField(
                        "total_income_gap_or_income_gain_client",
                        e.target.value
                      )
                    }
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="total_income_gap_or_income_gain_spouse"
                    className="text-center"
                    value={
                      formData.total_income_gap_or_income_gain_spouse || ""
                    }
                    onChange={(e) =>
                      handleStateByField(
                        "total_income_gap_or_income_gain_spouse",
                        e.target.value
                      )
                    }
                    onBlur={(event) => handleBlurFP(event, true, setformData)}
                    onFocus={(event) => handleFocusFP(event, setformData)}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    name="total_income_gap_or_income_gain_before_tax_total"
                    className="text-center"
                    value={
                      formData.total_income_gap_or_income_gain_before_tax_total ||
                      ""
                    }
                    onChange={(e) =>
                      handleStateByField(
                        "total_income_gap_or_income_gain_before_tax_total",
                        e.target.value
                      )
                    }
                    onBlur={(event) => handleBlurFP(event, true, setformData)}
                    onFocus={(event) => handleFocusFP(event, setformData)}
                  />
                </td>
                <td
                  className={"highlightNumber"}
                  style={{ padding: "0px 2px" }}
                >
                  <Form.Control
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    className="text-center"
                    name="total_income_gap_or_income_gain_after_tax_total"
                    value={
                      formData.total_income_gap_or_income_gain_after_tax_total ||
                      ""
                    }
                    onChange={(e) =>
                      handleStateByField(
                        "total_income_gap_or_income_gain_after_tax_total",
                        e.target.value
                      )
                    }
                    onBlur={(event) => handleBlurFP(event, true, setformData)}
                    onFocus={(event) => handleFocusFP(event, setformData)}
                  />
                </td>
              </tr>
            </tbody>
          </Table>
          <Table className="m-3 table-content table-ten" responsive="md">
            <tbody>
              <tr>
                <th colSpan={5} style={{ border: "unset !important" }}>
                  Investment Objectives & Investment Risk Tolerance
                </th>
              </tr>
              <tr>
                <td className="highlightNumber">
                  <div className="row">
                    <div className="col-5 px-1">
                      Is the safety of your money important to you or are you a
                      risk taker?{" "}
                    </div>
                    <div className="col px-0">
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="is_safety_of_money_important"
                        value={formData.is_safety_of_money_important || ""}
                        onChange={(e) =>
                          handleStateByField(
                            "is_safety_of_money_important",
                            e.target.value
                          )
                        }
                        className="text-center"
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td className="highlightNumber">
                  <div className="row">
                    <div className="col-9 px-0 ps-1">
                      At your age, how much do you feel you should risk in the
                      market and how much should you have protected, guaranteed
                      and safe?
                    </div>
                    <div className="col px-0 text-end pe-1">Risk % </div>
                    <div className="col px-0">
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="at_your_age_risk"
                        value={formData.at_your_age_risk || ""}
                        className="text-center"
                        onChange={(e) =>
                          handleStateByField("at_your_age_risk", e.target.value)
                        }
                        style={{ textAlign: "right !important", width: "32px" }}
                      />
                    </div>
                    <div className="col px-0 text-end pe-1"> Safe % </div>
                    <div className="col px-0">
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="at_your_age_risk_percentage"
                        value={formData.at_your_age_risk_percentage || ""}
                        className="text-center"
                        onChange={(e) =>
                          handleStateByField(
                            "at_your_age_risk_percentage",
                            e.target.value
                          )
                        }
                        style={{ textAlign: "right !important", width: "32px" }}
                      />
                    </div>
                    <div className="col px-0"></div>
                  </div>
                </td>
              </tr>
              <tr>
                <td className="highlightNumber">
                  <div className="row">
                    <div className="col px-1">
                      How much can you afford to lose (when would you say enough
                      is enough)?{" "}
                    </div>
                    <div className="col px-0">
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder=""
                        name="how_much_can_you_afford_to_lose"
                        value={formData.how_much_can_you_afford_to_lose || ""}
                        onChange={(e) =>
                          handleStateByField(
                            "how_much_can_you_afford_to_lose",
                            e.target.value
                          )
                        }
                        className="text-center"
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td></td>
              </tr>
            </tbody>
          </Table>
          <Table className="m-3 table-content table-eleven" responsive="md">
            <tr>
              <th colSpan={21} className="text-left">
                Check the number that best describes your attitude to investment
                risk{" "}
              </th>
            </tr>
            <tr>
              <th>Client</th>
              <th colSpan={20}>Conservative (Safe) ► Aggressive (Risky)</th>
            </tr>
            <tr>
              <td>Owner</td>
              <td className="highlightNumber">
                <div className="radio-inline thrift-aggressive-label">
                  {formData.tsp_ret_field5 && formData.tsp_ret_field5 == 1 ? (
                    <i className="fa fa-check-square-o thrift-checker"></i>
                  ) : (
                    <i className="fa fa-square-o thrift-checker2"></i>
                  )}
                  1
                </div>
              </td>
              <td className="highlightNumber">
                <div className="radio-inline thrift-aggressive-label">
                  {formData.tsp_ret_field5 && formData.tsp_ret_field5 == 2 ? (
                    <i className="fa fa-check-square-o thrift-checker"></i>
                  ) : (
                    <i className="fa fa-square-o thrift-checker2"></i>
                  )}
                  2
                </div>
              </td>
              <td className="highlightNumber">
                <div className="radio-inline thrift-aggressive-label">
                  {formData.tsp_ret_field5 && formData.tsp_ret_field5 == 3 ? (
                    <i className="fa fa-check-square-o thrift-checker"></i>
                  ) : (
                    <i className="fa fa-square-o thrift-checker2"></i>
                  )}
                  3
                </div>
              </td>
              <td className="highlightNumber">
                <div className="radio-inline thrift-aggressive-label">
                  {formData.tsp_ret_field5 && formData.tsp_ret_field5 == 4 ? (
                    <i className="fa fa-check-square-o thrift-checker"></i>
                  ) : (
                    <i className="fa fa-square-o thrift-checker2"></i>
                  )}
                  4
                </div>
              </td>
              <td className="highlightNumber">
                <div className="radio-inline thrift-aggressive-label">
                  {formData.tsp_ret_field5 && formData.tsp_ret_field5 == 5 ? (
                    <i className="fa fa-check-square-o thrift-checker"></i>
                  ) : (
                    <i className="fa fa-square-o thrift-checker2"></i>
                  )}
                  5
                </div>
              </td>
              <td className="highlightNumber">
                <div className="radio-inline thrift-aggressive-label">
                  {formData.tsp_ret_field5 && formData.tsp_ret_field5 == 6 ? (
                    <i className="fa fa-check-square-o thrift-checker"></i>
                  ) : (
                    <i className="fa fa-square-o thrift-checker2"></i>
                  )}
                  6
                </div>
              </td>
              <td className="highlightNumber">
                <div className="radio-inline thrift-aggressive-label">
                  {formData.tsp_ret_field5 && formData.tsp_ret_field5 == 7 ? (
                    <i className="fa fa-check-square-o thrift-checker"></i>
                  ) : (
                    <i className="fa fa-square-o thrift-checker2"></i>
                  )}
                  7
                </div>
              </td>
              <td className="highlightNumber">
                <div className="radio-inline thrift-aggressive-label">
                  {formData.tsp_ret_field5 && formData.tsp_ret_field5 == 8 ? (
                    <i className="fa fa-check-square-o thrift-checker"></i>
                  ) : (
                    <i className="fa fa-square-o thrift-checker2"></i>
                  )}
                  8
                </div>
              </td>
              <td className="highlightNumber">
                <div className="radio-inline thrift-aggressive-label">
                  {formData.tsp_ret_field5 && formData.tsp_ret_field5 == 9 ? (
                    <i className="fa fa-check-square-o thrift-checker"></i>
                  ) : (
                    <i className="fa fa-square-o thrift-checker2"></i>
                  )}
                  9
                </div>
              </td>
              <td className="highlightNumber">
                <div className="radio-inline thrift-aggressive-label">
                  {formData.tsp_ret_field5 && formData.tsp_ret_field5 == 10 ? (
                    <i className="fa fa-check-square-o thrift-checker"></i>
                  ) : (
                    <i className="fa fa-square-o thrift-checker2"></i>
                  )}
                  10
                </div>
              </td>
            </tr>
            <tr>
              <td>Joint Owner</td>
              <td className="highlightNumber">
                <div className="radio-inline thrift-aggressive-label">
                  {formData.spouse_risk_tol_level &&
                  formData.spouse_risk_tol_level == 1 ? (
                    <i className="fa fa-check-square-o thrift-checker"></i>
                  ) : (
                    <i className="fa fa-square-o thrift-checker2"></i>
                  )}
                  1
                </div>
              </td>
              <td className="highlightNumber">
                <div className="radio-inline thrift-aggressive-label">
                  {formData.spouse_risk_tol_level &&
                  formData.spouse_risk_tol_level == 2 ? (
                    <i className="fa fa-check-square-o thrift-checker"></i>
                  ) : (
                    <i className="fa fa-square-o thrift-checker2"></i>
                  )}
                  2
                </div>
              </td>
              <td className="highlightNumber">
                <div className="radio-inline thrift-aggressive-label">
                  {formData.spouse_risk_tol_level &&
                  formData.spouse_risk_tol_level == 3 ? (
                    <i className="fa fa-check-square-o thrift-checker"></i>
                  ) : (
                    <i className="fa fa-square-o thrift-checker2"></i>
                  )}
                  3
                </div>
              </td>
              <td className="highlightNumber">
                <div className="radio-inline thrift-aggressive-label">
                  {formData.spouse_risk_tol_level &&
                  formData.spouse_risk_tol_level == 4 ? (
                    <i className="fa fa-check-square-o thrift-checker"></i>
                  ) : (
                    <i className="fa fa-square-o thrift-checker2"></i>
                  )}
                  4
                </div>
              </td>
              <td className="highlightNumber">
                <div className="radio-inline thrift-aggressive-label">
                  {formData.spouse_risk_tol_level &&
                  formData.spouse_risk_tol_level == 5 ? (
                    <i className="fa fa-check-square-o thrift-checker"></i>
                  ) : (
                    <i className="fa fa-square-o thrift-checker2"></i>
                  )}
                  5
                </div>
              </td>
              <td className="highlightNumber">
                <div className="radio-inline thrift-aggressive-label">
                  {formData.spouse_risk_tol_level &&
                  formData.spouse_risk_tol_level == 6 ? (
                    <i className="fa fa-check-square-o thrift-checker"></i>
                  ) : (
                    <i className="fa fa-square-o thrift-checker2"></i>
                  )}
                  6
                </div>
              </td>
              <td className="highlightNumber">
                <div className="radio-inline thrift-aggressive-label">
                  {formData.spouse_risk_tol_level &&
                  formData.spouse_risk_tol_level == 7 ? (
                    <i className="fa fa-check-square-o thrift-checker"></i>
                  ) : (
                    <i className="fa fa-square-o thrift-checker2"></i>
                  )}
                  7
                </div>
              </td>
              <td className="highlightNumber">
                <div className="radio-inline thrift-aggressive-label">
                  {formData.spouse_risk_tol_level &&
                  formData.spouse_risk_tol_level == 8 ? (
                    <i className="fa fa-check-square-o thrift-checker"></i>
                  ) : (
                    <i className="fa fa-square-o thrift-checker2"></i>
                  )}
                  8
                </div>
              </td>
              <td className="highlightNumber">
                <div className="radio-inline thrift-aggressive-label">
                  {formData.spouse_risk_tol_level &&
                  formData.spouse_risk_tol_level == 9 ? (
                    <i className="fa fa-check-square-o thrift-checker"></i>
                  ) : (
                    <i className="fa fa-square-o thrift-checker2"></i>
                  )}
                  9
                </div>
              </td>
              <td className="highlightNumber">
                <div className="radio-inline thrift-aggressive-label">
                  {formData.spouse_risk_tol_level &&
                  formData.spouse_risk_tol_level == 10 ? (
                    <i className="fa fa-check-square-o thrift-checker"></i>
                  ) : (
                    <i className="fa fa-square-o thrift-checker2"></i>
                  )}
                  10
                </div>
              </td>
            </tr>
          </Table>
          <Table className="m-3 table-content table-twelve" responsive="md">
            <tr>
              <th colSpan={3} style={{ border: "unset !important" }}>
                Section J: Planning Objectives{" "}
              </th>
            </tr>
            <tr className="text-center">
              <th>Objectives</th>
              <th>Owner</th>
              <th>Spouse</th>
            </tr>
            <tr>
              <td>No Principal Losses with Potential Gains</td>
              <td className="highlightNumber">
                <Form.Control
                  as="select"
                  name="no_principal_losses_with_potential_gains_owner"
                  className="text-center"
                  defaultValue=""
                  onChange={(e) =>
                    handleStateByField(
                      "no_principal_losses_with_potential_gains_owner",
                      e.target.value
                    )
                  }
                >
                  <option
                    value="Yes"
                    selected={
                      formData.no_principal_losses_with_potential_gains_owner ==
                      "Yes"
                    }
                  >
                    Yes
                  </option>
                  <option
                    value="No"
                    selected={
                      formData.no_principal_losses_with_potential_gains_owner ==
                      "No"
                    }
                  >
                    No
                  </option>
                </Form.Control>
              </td>
              <td className="highlightNumber">
                <Form.Control
                  as="select"
                  name="no_principal_losses_with_potential_gains_spouse"
                  className="text-center"
                  defaultValue=""
                  onChange={(e) =>
                    handleStateByField(
                      "no_principal_losses_with_potential_gains_spouse",
                      e.target.value
                    )
                  }
                >
                  <option
                    value="Yes"
                    selected={
                      formData.no_principal_losses_with_potential_gains_spouse ==
                      "Yes"
                    }
                  >
                    Yes
                  </option>
                  <option
                    value="No"
                    selected={
                      formData.no_principal_losses_with_potential_gains_spouse ==
                      "No"
                    }
                  >
                    No
                  </option>
                </Form.Control>
              </td>
            </tr>
            <tr>
              <td>Retirement Income for Life</td>
              <td className="highlightNumber">
                <Form.Control
                  as="select"
                  name="retirement_income_for_life_owner"
                  className="text-center"
                  defaultValue=""
                  onChange={(e) =>
                    handleStateByField(
                      "retirement_income_for_life_owner",
                      e.target.value
                    )
                  }
                >
                  <option
                    value="Yes"
                    selected={
                      formData.retirement_income_for_life_owner == "Yes"
                    }
                  >
                    Yes
                  </option>
                  <option
                    value="No"
                    selected={formData.retirement_income_for_life_owner == "No"}
                  >
                    No
                  </option>
                </Form.Control>
              </td>
              <td className="highlightNumber">
                <Form.Control
                  as="select"
                  name="retirement_income_for_life_spouse"
                  className="text-center"
                  onChange={(e) =>
                    handleStateByField(
                      "retirement_income_for_life_spouse",
                      e.target.value
                    )
                  }
                  defaultValue=""
                >
                  <option
                    value="Yes"
                    selected={
                      formData.retirement_income_for_life_spouse == "Yes"
                    }
                  >
                    Yes
                  </option>
                  <option
                    value="No"
                    selected={
                      formData.retirement_income_for_life_spouse == "No"
                    }
                  >
                    No
                  </option>
                </Form.Control>
              </td>
            </tr>
            <tr>
              <td>Access to Your Money</td>
              <td className="highlightNumber">
                <Form.Control
                  as="select"
                  name="access_to_your_money_owner"
                  className="text-center"
                  onChange={(e) =>
                    handleStateByField(
                      "access_to_your_money_owner",
                      e.target.value
                    )
                  }
                  defaultValue=""
                >
                  <option
                    value="Yes"
                    selected={formData.access_to_your_money_owner == "Yes"}
                  >
                    Yes
                  </option>
                  <option
                    value="No"
                    selected={formData.access_to_your_money_owner == "No"}
                  >
                    No
                  </option>
                </Form.Control>
              </td>
              <td className="highlightNumber">
                <Form.Control
                  as="select"
                  name="access_to_your_money_spouse"
                  className="text-center"
                  onChange={(e) =>
                    handleStateByField(
                      "access_to_your_money_spouse",
                      e.target.value
                    )
                  }
                  defaultValue=""
                >
                  <option
                    value="Yes"
                    selected={formData.access_to_your_money_spouse == "Yes"}
                  >
                    Yes
                  </option>
                  <option
                    value="No"
                    selected={formData.access_to_your_money_spouse == "No"}
                  >
                    No
                  </option>
                </Form.Control>
              </td>
            </tr>
            <tr>
              <td>Income for In-Home Care (2 of 6 ADL’s)</td>
              <td className="highlightNumber">
                <Form.Control
                  as="select"
                  name="income_for_in_home_care_owner"
                  className="text-center"
                  onChange={(e) =>
                    handleStateByField(
                      "income_for_in_home_care_owner",
                      e.target.value
                    )
                  }
                  defaultValue=""
                >
                  <option
                    value="Yes"
                    selected={formData.income_for_in_home_care_owner == "Yes"}
                  >
                    Yes
                  </option>
                  <option
                    value="No"
                    selected={formData.income_for_in_home_care_owner == "No"}
                  >
                    No
                  </option>
                </Form.Control>
              </td>
              <td className="highlightNumber">
                <Form.Control
                  as="select"
                  name="income_for_in_home_care_spouse"
                  className="text-center"
                  onChange={(e) =>
                    handleStateByField(
                      "income_for_in_home_care_spouse",
                      e.target.value
                    )
                  }
                  defaultValue=""
                >
                  <option
                    value="Yes"
                    selected={formData.income_for_in_home_care_spouse == "Yes"}
                  >
                    Yes
                  </option>
                  <option
                    value="No"
                    selected={formData.income_for_in_home_care_spouse == "No"}
                  >
                    No
                  </option>
                </Form.Control>
              </td>
            </tr>
            <tr>
              <td>Income for Nursing Home Care</td>
              <td className="highlightNumber">
                <Form.Control
                  as="select"
                  name="income_for_nursing_home_care_owner"
                  className="text-center"
                  onChange={(e) =>
                    handleStateByField(
                      "income_for_nursing_home_care_owner",
                      e.target.value
                    )
                  }
                  defaultValue=""
                >
                  <option
                    value="Yes"
                    selected={
                      formData.income_for_nursing_home_care_owner == "Yes"
                    }
                  >
                    Yes
                  </option>
                  <option
                    value="No"
                    selected={
                      formData.income_for_nursing_home_care_owner == "No"
                    }
                  >
                    No
                  </option>
                </Form.Control>
              </td>
              <td className="highlightNumber">
                <Form.Control
                  as="select"
                  name="income_for_nursing_home_care_spouse"
                  className="text-center"
                  onChange={(e) =>
                    handleStateByField(
                      "income_for_nursing_home_care_spouse",
                      e.target.value
                    )
                  }
                  defaultValue=""
                >
                  <option
                    value="Yes"
                    selected={
                      formData.income_for_nursing_home_care_spouse == "Yes"
                    }
                  >
                    Yes
                  </option>
                  <option
                    value="No"
                    selected={
                      formData.income_for_nursing_home_care_spouse == "No"
                    }
                  >
                    No
                  </option>
                </Form.Control>
              </td>
            </tr>
          </Table>
          <Table className="m-3 table-content table-fourteen" responsive="md">
            <tr>
              <th colSpan={3} style={{ border: "unset !important" }}>
                Section K: Retirement Income for Life
              </th>
            </tr>
            <tr>
              <td className="highlightNumber">Income Now</td>
              <td className="highlightNumber">
                {formData.income_now_owner && formData.income_now_owner == 1 ? (
                  <i
                    className="fa fa-check-square-o thrift-checker"
                    onClick={() => handleStateByField("income_now_owner", 0)}
                  ></i>
                ) : (
                  <i
                    className="fa fa-square-o thrift-checker2"
                    onClick={() => handleStateByField("income_now_owner", 1)}
                  ></i>
                )}
              </td>
              <td className="highlightNumber">Income in 1 – 5 years</td>
              <td className="highlightNumber">
                {formData.income_in_1_5_years &&
                formData.income_in_1_5_years == 1 ? (
                  <i
                    className="fa fa-check-square-o thrift-checker"
                    onClick={() => handleStateByField("income_in_1_5_years", 0)}
                  ></i>
                ) : (
                  <i
                    className="fa fa-square-o thrift-checker2"
                    onClick={() => handleStateByField("income_in_1_5_years", 1)}
                  ></i>
                )}
              </td>
            </tr>
            <tr>
              <td className="highlightNumber">Income in 6 – 10 years</td>
              <td className="highlightNumber">
                {formData.income_in_6_10_years &&
                formData.income_in_6_10_years == 1 ? (
                  <i
                    className="fa fa-check-square-o thrift-checker"
                    onClick={() =>
                      handleStateByField("income_in_6_10_years", 0)
                    }
                  ></i>
                ) : (
                  <i
                    className="fa fa-square-o thrift-checker2"
                    onClick={() =>
                      handleStateByField("income_in_6_10_years", 1)
                    }
                  ></i>
                )}
              </td>
              <td className="highlightNumber">Inheritance / RMD’s Only</td>
              <td className="highlightNumber">
                {formData.inheritance_rmd_only &&
                formData.inheritance_rmd_only == 1 ? (
                  <i
                    className="fa fa-check-square-o thrift-checker"
                    onClick={() =>
                      handleStateByField("inheritance_rmd_only", 0)
                    }
                  ></i>
                ) : (
                  <i
                    className="fa fa-square-o thrift-checker2"
                    onClick={() =>
                      handleStateByField("inheritance_rmd_only", 1)
                    }
                  ></i>
                )}
              </td>
            </tr>
          </Table>
          <Table className="m-3 table-content table-thirteen" responsive="md">
            <tr>
              <th colSpan={2} style={{ border: "unset !important" }}>
                Section M: Notes
              </th>
            </tr>
            <tr>
              <td className="highlightNumber">
                <Form.Control
                  as="textarea"
                  name="pf_additional_notes"
                  value={formData.pf_additional_notes || ""}
                  className="pf_additional_notes_textarea"
                  onChange={(e) =>
                    handleStateByField("pf_additional_notes", e.target.value)
                  }
                  style={{ textAlign: "left !important" }}
                  rows={3}
                />
              </td>
            </tr>
          </Table>
          {/* <Table className="m-3 table-content table-fifteen" responsive="md">
            <tr>
              <td className="highlightNumber">
                <div
                  className="text-center"
                  style={{
                    color: "#b32828",
                    fontWeight: "bold",
                  }}
                >
                  RETIREMENT INCOME ESTIMATE
                </div>
                <div className="row p-0 px-2">
                  <div
                    className="col p-0"
                    style={{
                      color: "#b32828",
                      fontWeight: "bold",
                      maxWidth: "30px",
                    }}
                  >
                    (
                  </div>
                  <div
                    className="col p-0"
                    style={{
                      maxWidth: "40px",
                    }}
                  >
                    <Form.Control
                      type="text"
                      name="pf_age"
                      className="additional-notes-textarea"
                      placeholder="0"
                      value={formData.MRA ? parseInt(formData.MRA) : ""}
                      disabled={true}
                      style={{ color: "#b32828", width: "30px" }}
                    />
                    <span style={{ fontSize: "16px", color: "#b32828" }}>
                      Age:
                    </span>
                  </div>
                  <div
                    className="col p-0"
                    style={{
                      color: "#b32828",
                      fontWeight: "bold",
                      maxWidth: "30px",
                    }}
                  >
                    )
                  </div>
                  <div className="col p-0">
                    <Form.Control
                      type="text"
                      name="pf_fers"
                      value={
                        formData.reduced_monthly_income
                          ? "$" +
                            formatValue(
                              convertValue(formData.reduced_monthly_income)
                            )
                          : ""
                      }
                      disabled={true}
                      className="additional-notes-textarea"
                      placeholder="$0.00"
                    />
                    <span style={{ fontSize: "16px", color: "#000" }}>
                      FERS
                    </span>
                  </div>
                  <div className="col p-0">+</div>
                  <div className="col p-0">
                    <Form.Control
                      type="text"
                      name="pf_tsp"
                      value={"$0"}
                      disabled={true}
                      className="additional-notes-textarea"
                      placeholder="$0.00"
                    />
                    <span style={{ fontSize: "16px", color: "#000" }}>TSP</span>
                  </div>
                  <div className="col p-0">+</div>
                  <div className="col p-0">
                    <Form.Control
                      type="text"
                      name="pf_srs"
                      value={
                        formData.age_62_ss_benefit_final
                          ? "$" + formatValue(formData.age_62_ss_benefit_final)
                          : ""
                      }
                      disabled={true}
                      className="additional-notes-textarea"
                      placeholder="$0.00"
                    />
                    <span style={{ fontSize: "16px", color: "#000" }}>SRS</span>
                  </div>
                  <div className="col p-0">+</div>
                  <div className="col p-0">
                    <Form.Control
                      type="text"
                      name="pf_other"
                      value={
                        formData.additional_sources_of_income_at_retire_other_income_amount
                          ? "$" +
                            formatValue(
                              formData.additional_sources_of_income_at_retire_other_income_amount
                            )
                          : ""
                      }
                      disabled={true}
                      className="additional-notes-textarea"
                      placeholder="$0.00"
                    />
                    <span style={{ fontSize: "16px", color: "#000" }}>
                      Other
                    </span>
                  </div>
                  <div className="col p-0">=</div>
                  <div className="col p-0">
                    <Form.Control
                      type="text"
                      name="pf_total"
                      value={
                        "$" +
                        formatValue(
                          convertValue(formData.reduced_monthly_income) +
                            convertValue(formData.age_62_ss_benefit_final) +
                            convertValue(
                              formData.additional_sources_of_income_at_retire_other_income_amount
                            )
                        )
                      }
                      disabled={true}
                      className="additional-notes-textarea"
                      placeholder="$0.00"
                    />
                    <span style={{ fontSize: "16px", color: "#000" }}>
                      TOTAL
                    </span>
                  </div>
                </div>
                <div className="row p-0 px-2">
                  <div
                    className="col p-0"
                    style={{
                      color: "#b32828",
                      fontWeight: "bold",
                      maxWidth: "30px",
                    }}
                  >
                    (
                  </div>
                  <div
                    className="col p-0"
                    style={{
                      maxWidth: "40px",
                    }}
                  >
                    <Form.Control
                      type="text"
                      name="pf_age2"
                      value={formData.pf_age2 || ""}
                      onChange={(e) =>
                        handleStateByField("pf_age2", e.target.value)
                      }
                      className="additional-notes-textarea"
                      placeholder="0"
                      style={{ color: "#b32828", width: "30px" }}
                    />
                    <span style={{ fontSize: "16px", color: "#b32828" }}>
                      Age:
                    </span>
                  </div>
                  <div
                    className="col p-0"
                    style={{
                      color: "#b32828",
                      fontWeight: "bold",
                      maxWidth: "30px",
                    }}
                  >
                    )
                  </div>
                  <div className="col p-0">
                    <Form.Control
                      type="text"
                      name="pf_fers2"
                      value={formData.pf_fers2 || ""}
                      onChange={(e) =>
                        handleStateByField("pf_fers2", e.target.value)
                      }
                      className="additional-notes-textarea"
                      placeholder="$0.00"
                    />
                    <span style={{ fontSize: "16px", color: "#000" }}>
                      FERS
                    </span>
                  </div>
                  <div className="col p-0">+</div>
                  <div className="col p-0">
                    <Form.Control
                      type="text"
                      name="pf_tsp2"
                      value={formData.pf_tsp2 || ""}
                      onChange={(e) =>
                        handleStateByField("pf_tsp2", e.target.value)
                      }
                      className="additional-notes-textarea"
                      placeholder="$0.00"
                    />
                    <span style={{ fontSize: "16px", color: "#000" }}>TSP</span>
                  </div>
                  <div className="col p-0">+</div>
                  <div className="col p-0">
                    <Form.Control
                      type="text"
                      name="pf_srs2"
                      value={formData.pf_srs2 || ""}
                      onChange={(e) =>
                        handleStateByField("pf_srs2", e.target.value)
                      }
                      className="additional-notes-textarea"
                      placeholder="$0.00"
                    />
                    <span style={{ fontSize: "16px", color: "#000" }}>SRS</span>
                  </div>
                  <div className="col p-0">+</div>
                  <div className="col p-0">
                    <Form.Control
                      type="text"
                      name="pf_other2"
                      value={formData.pf_other2 || ""}
                      onChange={(e) =>
                        handleStateByField("pf_other2", e.target.value)
                      }
                      className="additional-notes-textarea"
                      placeholder="$0.00"
                    />
                    <span style={{ fontSize: "16px", color: "#000" }}>
                      Other
                    </span>
                  </div>
                  <div className="col p-0">=</div>
                  <div className="col p-0">
                    <Form.Control
                      type="text"
                      name="pf_total2"
                      value={formData.pf_total2 || ""}
                      onChange={(e) =>
                        handleStateByField("pf_total2", e.target.value)
                      }
                      className="additional-notes-textarea"
                      placeholder="$0.00"
                    />
                    <span style={{ fontSize: "16px", color: "#000" }}>
                      TOTAL
                    </span>
                  </div>
                </div>
                <div className="row p-0 px-2">
                  <div
                    className="col p-0"
                    style={{
                      color: "#b32828",
                      fontWeight: "bold",
                      maxWidth: "30px",
                    }}
                  >
                    (
                  </div>
                  <div
                    className="col p-0"
                    style={{
                      maxWidth: "40px",
                    }}
                  >
                    <Form.Control
                      type="text"
                      name="pf_age3"
                      value={"70"}
                      disabled={true}
                      className="additional-notes-textarea"
                      placeholder="0"
                      style={{ color: "#b32828", width: "30px" }}
                    />
                    <span style={{ fontSize: "16px", color: "#b32828" }}>
                      Age:
                    </span>
                  </div>
                  <div
                    className="col p-0"
                    style={{
                      color: "#b32828",
                      fontWeight: "bold",
                      maxWidth: "30px",
                    }}
                  >
                    )
                  </div>
                  <div className="col p-0">
                    <Form.Control
                      type="text"
                      name="pf_fers3"
                      value={
                        formData.reduced_monthly_income
                          ? "$" +
                            formatValue(
                              convertValue(formData.reduced_monthly_income)
                            )
                          : ""
                      }
                      disabled={true}
                      className="additional-notes-textarea"
                      placeholder="$0.00"
                    />
                    <span style={{ fontSize: "16px", color: "#000" }}>
                      FERS
                    </span>
                  </div>
                  <div className="col p-0">+</div>
                  <div className="col p-0">
                    <Form.Control
                      type="text"
                      name="pf_tsp3"
                      value={formData.pf_tsp3 || ""}
                      disabled={true}
                      className="additional-notes-textarea"
                      placeholder="$0.00"
                    />
                    <span style={{ fontSize: "16px", color: "#000" }}>TSP</span>
                  </div>
                  <div className="col p-0">+</div>
                  <div className="col p-0">
                    <Form.Control
                      type="text"
                      name="pf_srs3"
                      value={
                        formData.s8s2_income_amount &&
                        formData.s8s2_age_to_begin <= 70
                          ? formatValue(
                              convertValue(formData.s8s2_income_amount)
                            )
                          : "$0.0"
                      }
                      disabled={true}
                      className="additional-notes-textarea"
                      placeholder="$0.00"
                    />
                    <span style={{ fontSize: "16px", color: "#000" }}>SS</span>
                  </div>
                  <div className="col p-0">+</div>
                  <div className="col p-0">
                    <Form.Control
                      type="text"
                      name="pf_other3"
                      value={
                        formData.additional_sources_of_income_at_retire_other_income_amount
                          ? "$" +
                            formatValue(
                              formData.additional_sources_of_income_at_retire_other_income_amount
                            )
                          : ""
                      }
                      disabled={true}
                      className="additional-notes-textarea"
                      placeholder="$0.00"
                    />
                    <span style={{ fontSize: "16px", color: "#000" }}>
                      Other
                    </span>
                  </div>
                  <div className="col p-0">=</div>
                  <div className="col p-0">
                    <Form.Control
                      type="text"
                      name="pf_total3"
                      value={
                        "$" +
                        formatValue(
                          convertValue(formData.reduced_monthly_income) +
                            convertValue(
                              formData.s8s2_income_amount &&
                                formData.s8s2_age_to_begin <= 70
                                ? formData.s8s2_income_amount
                                : "0.0"
                            ) +
                            convertValue(
                              formData.additional_sources_of_income_at_retire_other_income_amount
                            )
                        )
                      }
                      disabled={true}
                      className="additional-notes-textarea"
                      placeholder="$0.00"
                    />
                    <span style={{ fontSize: "16px", color: "#000" }}>
                      TOTAL
                    </span>
                  </div>
                </div>
              </td>
            </tr>
          </Table> */}
          <Table
            className="m-3 table-content table-sixteen"
            responsive="md"
            style={{ width: "100%" }}
          >
            <tr>
              <th className="highlightNumber">
                Client Signature (typed):
                <Form.Control
                  type="text"
                  name="client_signature"
                  style={{
                    display: "inline",
                    width: "auto",
                    marginLeft: "5px",
                  }}
                  onChange={(e) =>
                    handleStateByField("client_signature", e.target.value)
                  }
                  value={formData.client_signature || ""}
                />
              </th>
              <th className="highlightNumber">
                Agent Signature (typed):
                <Form.Control
                  type="text"
                  name="agent_signature"
                  style={{
                    display: "inline",
                    width: "auto",
                    marginLeft: "5px",
                  }}
                  onChange={(e) =>
                    handleStateByField("agent_signature", e.target.value)
                  }
                  value={formData.agent_signature || ""}
                />
              </th>
              <th className="highlightNumber">
                Next Appt. Date:
                <Form.Control
                  autoComplete="off"
                  type="date"
                  placeholder=""
                  name="next_app_Date"
                  className="text-center"
                  value={
                    formData.next_app_Date
                      ? moment(formData.next_app_Date).format("YYYY-MM-DD")
                      : ""
                  }
                  style={{
                    display: "inline",
                    width: "auto",
                    marginLeft: "5px",
                  }}
                  onChange={(e) =>
                    handleStateByField("next_app_Date", e.target.value)
                  }
                />
              </th>
            </tr>
          </Table>
          <div className="mt-4 mb-2 d-flex justify-content-center submit">
            <div className="text-center">
              <button className="btn-next btn question-next" type="submit">
                CONTINUE
              </button>
            </div>
          </div>
        </Form>
      </Card.Body>
    </>
  );
};

export default FinancialProfile;
